var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.94815e-06 1.26732L0.933331 0.333984L4.16667 3.55065C4.42222 3.80621 4.71111 4.00065 5.03333 4.13398C5.35555 4.26732 5.69444 4.33398 6.05 4.33398L9.45 4.33398L8.4 3.26732L9.33333 2.33398L12 5.00065L9.33333 7.66732L8.4 6.73398L9.45 5.66732L6.05 5.66732C5.69444 5.66732 5.35555 5.73398 5.03333 5.86732C4.71111 6.00065 4.42222 6.1951 4.16667 6.45065L0.933331 9.66732L-2.27452e-06 8.73398L3.73333 5.00065L-1.94815e-06 1.26732Z",
    fill: "#2F4B82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.145a9fdf4c9fae90aae8dfd44d4e8a9b.svg";
export { ForwardRef as ReactComponent };